/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoordinatorAssignmentItem } from '../models/CoordinatorAssignmentItem'
import type { DashboardMetricsResponse } from '../models/DashboardMetricsResponse'
import type { DashboardStatusBreakdownItem } from '../models/DashboardStatusBreakdownItem'
import type { RecordRetrievalStatusResponse } from '../models/RecordRetrievalStatusResponse'
import type { ReferrerAggregationItem } from '../models/ReferrerAggregationItem'
import type { SubjectLocationItem } from '../models/SubjectLocationItem'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenDashboardService {
    /**
     * Get Dashboard Metrics
     * Return total counts for candidates, patients, and care partners.
     * @returns DashboardMetricsResponse Successful Response
     * @throws ApiError
     */
    public static getDashboardMetricsDashboardMetricsGet(): CancelablePromise<DashboardMetricsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/metrics'
        })
    }
    /**
     * Get Status Breakdown
     * Return status breakdown for a subject type, as {status, count, percentage}.
     * @returns DashboardStatusBreakdownItem Successful Response
     * @throws ApiError
     */
    public static getStatusBreakdownDashboardStatusBreakdownGet({
        type
    }: {
        /**
         * Subject type to filter by
         */
        type: 'candidate' | 'carePartner'
    }): CancelablePromise<Array<DashboardStatusBreakdownItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/status-breakdown',
            query: {
                type: type
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Record Retrieval Status
     * Return counts for record retrieval statuses across patient requests.
     * @returns RecordRetrievalStatusResponse Successful Response
     * @throws ApiError
     */
    public static getRecordRetrievalStatusDashboardRecordRetrievalStatusGet(): CancelablePromise<RecordRetrievalStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/record-retrieval-status'
        })
    }
    /**
     * Get Coordinator Assignments
     * Return coordinator assignment counts for candidates and patients.
     * Includes coordinators with zero assignments.
     * @returns CoordinatorAssignmentItem Successful Response
     * @throws ApiError
     */
    public static getCoordinatorAssignmentsDashboardCoordinatorAssignmentsGet(): CancelablePromise<Array<CoordinatorAssignmentItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/coordinator-assignments'
        })
    }
    /**
     * Get Subject Locations
     * Return subject locations as {state_code, state_name, count}
     * @returns SubjectLocationItem Successful Response
     * @throws ApiError
     */
    public static getSubjectLocationsDashboardSubjectLocationsGet({
        type = 'all'
    }: {
        /**
         * Subject type to filter by
         */
        type?: 'candidate' | 'patient' | 'carepartner' | 'all'
    }): CancelablePromise<Array<SubjectLocationItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/subject-locations',
            query: {
                type: type
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Referrer Aggregation
     * Return candidate counts grouped by referrer_id.
     * @returns ReferrerAggregationItem Successful Response
     * @throws ApiError
     */
    public static getReferrerAggregationDashboardReferrerAggregationGet(): CancelablePromise<Array<ReferrerAggregationItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/dashboard/referrer-aggregation'
        })
    }
}
